import { css } from 'lit';

export const styles = css`
  .overlay-mask {
    pointer-events: auto;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: var(--affine-z-index-popover);
  }

  .slash-menu {
    position: fixed;
    left: 0;
    top: 0;
    box-sizing: border-box;
    padding: 6px;
    padding-right: 4px;
    width: 268px;
    overflow-y: auto;
    overflow-x: hidden;
    font-family: var(--affine-font-family);

    background: var(--affine-background-overlay-panel-color);
    box-shadow: var(--affine-menu-shadow);
    border-radius: 12px;
    z-index: var(--affine-z-index-popover);
    user-select: none;
  }

  .slash-menu::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
  }

  .slash-menu::-webkit-scrollbar-track {
    background: transparent;
    margin: 8px 0;
  }

  .slash-menu::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: transparent;
    transition: background-color 0.2s ease;
  }

  .slash-menu:hover::-webkit-scrollbar-thumb {
    background-color: var(--affine-black-10, rgba(0, 0, 0, 0.1));
  }

  .slash-menu::-webkit-scrollbar-thumb:hover {
    background-color: var(--affine-black-30, rgba(0, 0, 0, 0.3));
  }

  .slash-menu::-webkit-scrollbar-corner {
    display: none;
  }

  .slash-menu-group-name {
    box-sizing: border-box;
    padding: 10px 8px 4px 8px;

    font-size: var(--affine-font-xs);
    font-weight: 500;
    line-height: var(--affine-line-height);
    text-align: left;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    opacity: 0.7;
    color: var(
      --light-textColor-textSecondaryColor,
      var(--textColor-textSecondaryColor, #8e8d91)
    );
  }

  .slash-menu-group-name:first-child {
    padding-top: 4px;
  }

  .slash-menu-item {
    padding: 4px 8px;
    justify-content: flex-start;
    gap: 12px;
    border-radius: 8px;
    transition: all 0.15s ease;
  }

  .slash-menu-item:hover {
    background: var(--affine-hover-color);
  }

  .slash-menu-item-icon {
    box-sizing: border-box;
    width: 32px;
    height: 32px;
    padding: 6px;
    border: none;
    border-radius: 50%;
    color: var(--affine-icon-color);
    background: var(--affine-background-tertiary-color);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slash-menu-item:hover .slash-menu-item-icon {
    background: var(--affine-background-secondary-color);
    transform: scale(1.05);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  .slash-menu-item-icon svg {
    display: block;
    width: 18px;
    height: 18px;
  }

  .slash-menu-item.ask-ai {
    color: var(--affine-brand-color);
  }

  .slash-menu-item.ask-ai .slash-menu-item-icon {
    background: color-mix(in srgb, var(--affine-brand-color) 12%, transparent);
    color: var(--affine-brand-color);
  }

  .slash-menu-item.ask-ai:hover .slash-menu-item-icon {
    background: color-mix(in srgb, var(--affine-brand-color) 20%, transparent);
  }

  .slash-menu-item.github .github-icon {
    color: var(--affine-black);
  }
`;

export const slashItemToolTipStyle = css`
  .affine-tooltip {
    display: flex;
    padding: 6px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    border-radius: 12px;
  }

  .tooltip-figure {
    border-radius: 8px;
    overflow: hidden;
  }

  .tooltip-figure svg {
    display: block;
  }

  .tooltip-caption {
    padding: 2px 6px;
    color: var(
      --light-textColor-textSecondaryColor,
      var(--textColor-textSecondaryColor, #8e8d91)
    );
    font-family: var(--affine-font-family);
    font-size: var(--affine-font-xs);
    line-height: var(--affine-line-height);
    font-weight: 500;
    letter-spacing: 0.2px;
  }
`;
